import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-dev-ribbon',
    template: `<div class="dev-banner" *ngIf="label">{{ label }}</div>`,
    styles: [
        `
            .dev-banner {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                height: 22px;
                line-height: 22px;
                background: repeating-linear-gradient(
                    -45deg,
                    #e74c3c,
                    #e74c3c 10px,
                    #c0392b 10px,
                    #c0392b 20px
                );
                color: #fff;
                font-size: 10px;
                font-weight: 700;
                letter-spacing: 2px;
                text-transform: uppercase;
                text-align: center;
                font-family: sans-serif;
                z-index: 99999;
                pointer-events: none;
                text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
                box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
            }
        `,
    ],
})
export class DevRibbonComponent implements OnInit {
    label: string | null = null;

    constructor(private http: HttpClient) {}

    ngOnInit(): void {
        if (environment.production) return;

        this.http.get<{ environment: string }>(`${environment.baseUrl}/environment`).subscribe({
            next: (res) => {
                this.label = res?.environment?.toUpperCase() || 'DEVELOPMENT';
            },
            error: () => {
                this.label = 'DEVELOPMENT';
            },
        });
    }
}
